<template>
  <v-page page="bcmExplore" class="blue-grey--text text--darken-1">
    <v-container fluid ma-5>
      <!-- TITLE -->
      <v-row no-gutters justify="center">
        <v-col cols="4" xs="12" sm="12" md="10" lg="6">
          <v-row dense>
            <v-col>
              <v-card flat>
                <v-card-title class="text-h4">
                  Blueprint Content Manager
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <p>
                    Welcome to the Blueprint Content Manager (BCM). Your
                    one-stop-shop for blueprints, content, and management.
                  </p>

                  <disclaimer-panel>
                    <template v-slot:title>
                      This app is under development, click for details.
                    </template>
                    <template v-slot:content>
                        <p>
                          New features are being developed regularly. Please
                          Slack Alexi to report bugs or suggest features.
                        </p>
                        Recent updates:
                        <ul>
                          <li>
                            March 15, 2022
                            <ul>
                              <li>Explore page created</li>
                              <li>Redesigned profile pages</li>
                            </ul>
                          </li>
                        </ul>
                    </template>
                  </disclaimer-panel>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- EXPLORE TITLE -->
          <v-row dense justify="center">
            <v-col>
              <v-card flat>
                <v-card-title class="text-h5">Explore BCM</v-card-title>
              </v-card>
            </v-col>
          </v-row>

          <!-- EXPLORE CARDS - ROW 1 -->
          <v-row dense justify="center">
            <v-col>
              <explore-card
                title="Construct Frameworks"
                blurb="Manage costruct frameworks, constructs, and construct-to-item mappings."
                path="/bcm/constructs"
              ></explore-card>
            </v-col>
            <v-col>
              <explore-card
                title="Tasks"
                blurb="Manage task items, q-matrices, models, and more."
                path="/bcm/tasks"
              ></explore-card>
            </v-col>
            <v-col>
              <explore-card
                title="Items"
                blurb="Manage item names, definitions, item-to-construct mappings, and more."
                path="/bcm/items"
              ></explore-card>
            </v-col>
          </v-row>

          <!-- EXPLORE CARDS - ROW 2 -->
          <v-row dense>
            <v-col>
              <explore-card
                title="Q-Matrices"
                blurb="Manage q-matrix authority, mappings, and more."
                path="/bcm/matrices"
              ></explore-card>
            </v-col>
            <v-col>
              <explore-card
                title="Models"
                blurb="Manage models."
                path="/bcm/models"
              ></explore-card>
            </v-col>
            <v-col>
              <explore-card
                title="Forms"
                blurb="Manage form authority, definitions, and more."
                path="/bcm/forms"
              ></explore-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-page>
</template>

<script>
import VPage from '@/layouts/Default'
import ExploreCard from '../UI/ExploreCard.vue'
import { Bus } from '@/bus'
import DisclaimerPanel from '../UI/DisclaimerPanel.vue'

export default {
  name: 'bcmExplore',
  components: { VPage, ExploreCard, DisclaimerPanel },
  data () {
    return {
      tasks: [],
      taskItems: []
    }
  },
  async created () {
    await this.initialize()
  },
  methods: {
    async initialize () {
      await this.getTasks()
      await this.getTaskItems()
    },
    async getTasks () {
      try {
        this.tasks = await this.$store.dispatch(
          'bcm/fetchBlueprintTasks',
          this.attribute ? { type: this.attribute, values: this.query } : null
        )
      } catch (err) {
        Bus.$emit('alert', {
          color: 'error',
          message: 'Failed to retrieve Blueprint Content Manager Tasks'
        })
      }
    },
    async getTaskItems () {
      try {
        this.taskItems = await this.$store.dispatch(
          'bcm/fetchTaskItems',
          this.attribute ? { type: this.attribute, values: this.query } : null
        )
      } catch (err) {
        Bus.$emit('alert', {
          color: 'error',
          message: 'Failed to retrieve Blueprint Content Manager Task Items'
        })
      }
    }
  }
}
</script>
